module.exports=function(scope){ return `// Signal to the FaceTec SDK the type of audit trail that should be captured.
ZoomSDK.auditTrailType = ZoomSDK.ZoomAuditTrailType.FullResolution;

// Capture a User Session
zoomSession.capture();

// Sample code to handle the session result
function onZoomSessionComplete(zoomResult) {
   if(zoomResult.faceMetrics) {
       // Get the auidt trail image(s) if available
       var auditTrail = zoomResult.faceMetrics.auditTrailCompressedBase64;
   }
   // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/web/07-zoom-audit-trail.js.tpl